import { Camera, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";

import useSettings from "../../settings/useSettings";
import "./public-footer.css";

const fallbackHandle = "@slcupcakery";
const fallbackInstagramUrl = "https://www.instagram.com/slcupcakery";
const southCentralUrl = "https://southcentraldev.com";

function phoneHref(phone) {
  const digits = (phone || "").replace(/[^+\d]/g, "");
  return digits ? `tel:${digits}` : "tel:+12405202840";
}

function displayPhone(phone) {
  return phone || "240-520-2840";
}

const customerContactEmail = "orders@slcupcakery.com";

function displayEmail() {
  return customerContactEmail;
}

export default function PublicFooter() {
  const { settings } = useSettings();
  const socialHandle = settings?.social_handle || fallbackHandle;
  const instagramUrl = settings?.instagram_url || fallbackInstagramUrl;
  const facebookUrl = settings?.facebook_url || "";
  const email = displayEmail();
  const phone = displayPhone(settings?.business_phone);
  const location = [settings?.origin_city || "Silver Spring", settings?.origin_state || "Maryland"].filter(Boolean).join(", ");
  const noticeDays = settings?.delivery_summary?.minimum_notice_days;
  const noticeLabel = Number.isFinite(Number(noticeDays)) ? `${noticeDays} day notice` : "Advance notice required";

  return (
    <footer className="sugalumps-footer">
      <div className="sugalumps-footer__top">
        <div className="sugalumps-footer__brand">
          <Link to="/" className="sugalumps-brand">
            <span className="sugalumps-brand__mark">SL</span>
            <span className="sugalumps-brand__copy">
              <strong>SugaLumps</strong>
              <small>Cupcakery &amp; Sweet Treats</small>
            </span>
          </Link>

          <p>
            Gourmet cupcakes, pie pockets, dessert lumpia, pies, cheesecakes,
            and sweet treats delivered throughout the DMV.
          </p>

          <div className="sugalumps-footer__socials" aria-label="SugaLumps social links">
            <a href={instagramUrl} target="_blank" rel="noreferrer noopener" className="sugalumps-footer__social">
              <Camera size={18} />
              <span>Instagram {socialHandle}</span>
            </a>
            {facebookUrl ? (
              <a href={facebookUrl} target="_blank" rel="noreferrer noopener" className="sugalumps-footer__social">
                <MessageCircle size={18} />
                <span>Facebook {socialHandle}</span>
              </a>
            ) : (
              <span className="sugalumps-footer__social sugalumps-footer__social--inactive">
                <MessageCircle size={18} />
                <span>Facebook {socialHandle}</span>
              </span>
            )}
          </div>
        </div>

        <div className="sugalumps-footer__links">
          <div>
            <h3>Explore</h3>
            <Link to="/">Home</Link>
            <Link to="/menu">Menu</Link>
            <Link to="/about">About</Link>
            <Link to="/delivery">Delivery</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div>
            <h3>Order Information</h3>
            <span>Delivery only</span>
            <span>{noticeLabel}</span>
            <span>Serving the DMV</span>
            <span>Custom inquiries welcome</span>
          </div>

          <div>
            <h3>Contact</h3>
            <a href={phoneHref(phone)}>
              <Phone size={16} />
              {phone}
            </a>
            <a href={`mailto:${email}`}>
              <Mail size={16} />
              {email}
            </a>
            <span>
              <MapPin size={16} />
              {location}
            </span>
          </div>

          <div>
            <h3>Policies</h3>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>

      <div className="sugalumps-footer__bottom">
        <p>&copy; {new Date().getFullYear()} SugaLumps Cupcakery &amp; Sweet Treats. All rights reserved.</p>
        <p>
          Website by <a href={southCentralUrl} target="_blank" rel="noreferrer noopener">South Central Development</a>.
        </p>
      </div>
    </footer>
  );
}
